import { LitElement, html, css } from 'lit';

class WalletPopup extends LitElement {
  static properties = {
    onConfirm: { type: Function },
    onCancel: { type: Function }
  };

  static styles = css`
    .wallet-popup-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      padding: 20px;
      text-align: center;
    }

    .wallet-icon {
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
    }

    .wallet-icon svg {
      width: 40px;
      height: 40px;
      fill: white;
    }

    .popup-title {
      font-size: 24px;
      font-weight: 600;
      color: var(--text-primary-color, #333);
      margin: 0;
    }

    .popup-message {
      font-size: 16px;
      color: var(--text-secondary-color, #666);
      line-height: 1.5;
      margin: 0;
      max-width: 300px;
    }

    .popup-buttons {
      display: flex;
      gap: 12px;
      margin-top: 10px;
    }

    .popup-button {
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      border: none;
      min-width: 120px;
    }

    .primary-button {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
    }

    .primary-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .secondary-button {
      background: transparent;
      color: var(--text-secondary-color, #666);
      border: 1px solid var(--border-color, #ddd);
    }

    .secondary-button:hover {
      background: var(--bg-secondary-color, #f5f5f5);
    }
  `;

  handleGoToWallet() {
    if (this.onConfirm) {
      this.onConfirm();
    }
    // Navigate to wallet page
    window.location.href = '/wallet';
  }

  handleCancel() {
    if (this.onCancel) {
      this.onCancel();
    }
  }

  render() {
    return html`
      <div class="wallet-popup-container">
        <div class="wallet-icon">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
          </svg>
        </div>
        
        <h2 class="popup-title">Link Your Account</h2>
        
        <p class="popup-message">
          To complete this action, you need to link your wallet account. 
          This will allow you to proceed with the transaction securely.
        </p>
        
        <div class="popup-buttons">
          <button class="popup-button secondary-button" @click=${this.handleCancel}>
            Cancel
          </button>
          <button class="popup-button primary-button" @click=${this.handleGoToWallet}>
            Go to Wallet
          </button>
        </div>
      </div>
    `;
  }
}

customElements.define('wallet-popup', WalletPopup); 